module.exports = __webpack_public_path__ + "img/ig-btn.4a254df4.svg";